import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-28774727"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "goods-title"
};
const _hoisted_2 = {
  class: "goods-price"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "交易时间：", -1));
const _hoisted_4 = {
  class: "memo"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "金额：", -1));
const _hoisted_6 = {
  class: "memo"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "对方户名：", -1));
const _hoisted_8 = {
  class: "memo"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "对方账号：", -1));
const _hoisted_10 = {
  class: "memo"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "对方开户行：", -1));
const _hoisted_12 = {
  class: "memo"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "本方户名：", -1));
const _hoisted_14 = {
  class: "memo"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "本方银行：", -1));
const _hoisted_16 = {
  class: "memo"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "类型：", -1));
const _hoisted_18 = {
  class: "memo"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_loading = _resolveComponent("van-loading");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: "收款详细",
    "left-arrow": "",
    onClickLeft: $options.onClickLeft
  }, null, 8, ["onClickLeft"]), $data.show ? (_openBlock(), _createBlock(_component_van_cell_group, {
    key: 0,
    class: "goods"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, null, {
      title: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString($data.goods.oppAccountName), 1), _createElementVNode("div", _hoisted_2, _toDisplayString($data.goods.amount), 1)]),
      _: 1
    }), _createVNode(_component_van_cell, {
      class: "goods-express"
    }, {
      title: _withCtx(() => [_createVNode(_component_van_col, {
        style: {
          "float": "left",
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString($data.goods.tradeTime), 1)]),
        _: 1
      }), _createVNode(_component_van_col, {
        style: {
          "float": "left",
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString($data.goods.amount), 1)]),
        _: 1
      }), _createVNode(_component_van_col, {
        style: {
          "float": "left",
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString($data.goods.oppAccountName), 1)]),
        _: 1
      }), _createVNode(_component_van_col, {
        style: {
          "float": "left",
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString($data.goods.oppAccountNo), 1)]),
        _: 1
      }), _createVNode(_component_van_col, {
        style: {
          "float": "left",
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString($data.goods.oppOpenBankName), 1)]),
        _: 1
      }), _createVNode(_component_van_col, {
        style: {
          "float": "left",
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString($data.goods.accountName), 1)]),
        _: 1
      }), _createVNode(_component_van_col, {
        style: {
          "float": "left",
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString($data.goods.bankName), 1)]),
        _: 1
      }), _createVNode(_component_van_col, {
        style: {
          "float": "left",
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_hoisted_17, _createElementVNode("div", _hoisted_18, _toDisplayString($data.goods.payOrCollectionType), 1)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), $data.shows ? (_openBlock(), _createBlock(_component_van_loading, {
    key: 1,
    type: "spinner",
    style: {
      "text-align": "center",
      "margin": "60px"
    }
  })) : _createCommentVNode("", true)]);
}